"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageUploadSuccess = imageUploadSuccess;
exports.removeUploadedDynoImage = removeUploadedDynoImage;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _FileManagerUtils = require("lead-flows-ui/utils/FileManagerUtils");

function dynoImageRemove() {
  return {
    type: _ActionTypes.REMOVE_UPLOAD_DYNO_IMAGE
  };
}

function imageUploadSuccess(image) {
  return {
    type: _ActionTypes.UPLOAD_DYNO_IMAGE_SUCCESS,
    payload: {
      fileName: (0, _FileManagerUtils.getFileNameFromUrl)(image),
      originalUrl: image,
      resizedUrl: image
    }
  };
}

function removeUploadedDynoImage() {
  return function (dispatch) {
    return dispatch(dynoImageRemove());
  };
}